import { render } from "./DevelopBrand.vue?vue&type=template&id=1ba3ebe5&scoped=true"
import script from "./DevelopBrand.vue?vue&type=script&lang=js"
export * from "./DevelopBrand.vue?vue&type=script&lang=js"

import "./DevelopBrand.vue?vue&type=style&index=0&id=1ba3ebe5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba3ebe5"]])

export default __exports__